import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history } from '../router';
import LoadingDots from './ui/LoadingDots';
import ReactPaginate from 'react-paginate';
import { FORM_KIND, FORM_LABELS, PAGINATION, URL_PREFIX } from '../const/forms';
import {
  copyForm,
  deleteForm,
  revokeForm,
  getForms,
  getHistory,
  rejectApplication,
} from '../actions';
import { getProcessStatus } from './Utils';

import HistoryStatusModal from './program/history/';
import RejectionModal from './program/reject/';
import LastComment from '../modules/metajson-sub/src/core/modal/LastComment';
import { ActionsRules, ActionsDefaultState } from '../const/action_rules';

class RequestList extends Component {
  constructor() {
    super();
    this.onCopy = this.onCopy.bind(this);
    this.onRevoke = this.onRevoke.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.paginationClick = this.paginationClick.bind(this);
    this.modal = HistoryStatusModal;
    this.rejectionModal = RejectionModal;
    this.lastComment = LastComment;
  }

  goForm(event, opts) {
    event.stopPropagation();
    event.preventDefault();
    const { form_type, process_id } = opts;
    history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`);
  }

  onDelete = (form_type, process_id, form_kind) => event => {
    event.stopPropagation();
    event.preventDefault();
    this.props.deleteForm(form_type, process_id, form_kind ?? 0);
  };

  onCopy(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.copyForm(form_type, process_id);
  }

  showHistory(e, request) {
    e.stopPropagation();
    e.preventDefault();

    this.modal.show(request);
  }

  onRevoke(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.revokeForm(form_type, process_id);
  }
  getRowAct(item) {
    return item.stage_title;
  }
  getRowOp(item) {
    if (item.process_completed == true) {
      return 'Не требуется';
    }
    if (item.process_stage == 100) {
      return (
        <button
          onClick={event =>
            this.goForm(event, {
              form_type: item.init_type,
              process_id: item.process_id,
            })
          }
        >
          Заполнить
        </button>
      );
    }
    if (item.process_stage == 200) {
      return (
        <button
          onClick={event =>
            this.goForm(event, {
              form_type: item.form_type,
              process_id: item.process_id,
            })
          }
        >
          Отчёт
        </button>
      );
    }
  }

  paginationClick(e) {
    const page = e.selected + 1;

    this.props.getForms({ page, pagesize });
  }

  onShowLastComment(event, form_type, process_id) {
    event.stopPropagation();
    event.preventDefault();
    this.props.getHistory(process_id);
    this.lastComment.show();
  }

  onShowRejectionApplication = (event, form_type, process_id) => {
    event.stopPropagation();
    event.preventDefault();
    this.rejectionModal.show(
      form_type,
      process_id,
      this.props.rejectApplication,
    );
  };

  renderTableHead() {
    const view = this.props?.view;

    return (
      <thead>
        {view === 'adminFilters' ? (
          <tr>
            <td>№</td>
            <td>Вид заявителя</td>
            <td>Наименование заявителя</td>
            <td>Составитель</td>
            <td>Дата подачи</td>
            <td>Рег.№ в 1C-BPS</td>
            <td>Рег.№ в ЛК</td>
            <td>Статус</td>
          </tr>
        ) : null}
        {!view ? (
          <tr>
            <td>Компания</td>
            <td>Составитель</td>
            <td>Дата подачи</td>
            <td>Рег.№</td>
            <td>Стадия</td>
            <td>Статус</td>
            <td>Операции</td>
          </tr>
        ) : null}
      </thead>
    );
  }

  renderTableRow(item, mapId) {
    const { userInfo, view } = this.props;

    return (
      <tr
        className="report-list-group"
        key={item.process_id}
        onClick={event =>
          this.goForm(event, {
            form_type: item.form_type,
            process_id: item.process_id,
          })
        }
      >
        {view === 'adminFilters' ? (
          <>
            <td style={{ textAlign: 'center' }}>
              <b>{mapId + 1}</b>
            </td>
            <td>{FORM_KIND[`${item.form_kind}`] || ''}</td>
            <td>{item.company || ''}</td>
            <td>{item.creator || ''}</td>
            <td>{item.date || ''}</td>
            <td>{item.reg_num || ''}</td>
            <td>{item.process_id || ''}</td>
            <td>
              <div className="btn-group-vertical" role="group">
                <label className={`btn btn-${FORM_LABELS[item.form_status]}`}>
                  {getProcessStatus(item)}
                </label>
                {/*<button type="button" className="btn btn-default" onClick={(e) => this.showHistory(e, item.process_id)}>История изменений</button>*/}
              </div>
            </td>
          </>
        ) : null}
        {!view ? (
          <>
            <td>{item.company || ''}</td>
            <td>{item.creator || ''}</td>
            <td>{item.date || ''}</td>
            <td>{item.reg_num || ''}</td>
            <td>{item.stage_title}</td>
            <td>
              <div className="btn-group-vertical" role="group">
                <label className={`btn btn-${FORM_LABELS[item.form_status]}`}>
                  {getProcessStatus(item)}
                </label>
                {/*<button type="button" className="btn btn-default" onClick={(e) => this.showHistory(e, item.process_id)}>История изменений</button>*/}
              </div>
            </td>
            <td>
              {item.form_status === 0 ? (
                <button
                  className="btn btn-danger btn-xs"
                  onClick={this.onDelete(
                    item.form_type,
                    item.process_id,
                    item.form_kind,
                  )}
                  title="Удалить"
                >
                  <span className="glyphicon glyphicon-remove" />
                </button>
              ) : null}
              {/*
          <button className="btn btn-success btn-xs" onClick={event => this.onShowLastComment(event, item.form_type, item.process_id)} title="Последний комментарий">
            <span className="glyphicon glyphicon-comment" />
          </button>
          * */}

              {item.creator_email === userInfo.email ? (
                <button
                  className="btn btn-primary btn-xs"
                  onClick={event =>
                    this.onCopy(event, item?.form_type, item?.process_id)
                  }
                  title="Копировать"
                >
                  <span className="glyphicon glyphicon-duplicate" />
                </button>
              ) : null}

              {item.form_status === 7 ||
              item.form_status === 13 ||
              item.form_status === 9 ? (
                <button
                  className="btn btn-warning btn-xs"
                  onClick={event =>
                    this.onShowRejectionApplication(
                      event,
                      item.form_type,
                      item.process_id,
                    )
                  }
                  title="Отозвать"
                >
                  <span className="glyphicon glyphicon glyphicon-circle-arrow-left" />
                </button>
              ) : (
                ''
              )}
              {item.file_formal_check_conclusion && (
                <a
                  className="btn btn-primary btn-xs"
                  title="Формальная проверка"
                  download
                  href={item.file_formal_check_conclusion.url}
                  onClick={event => event.stopPropagation()}
                >
                  <span className="glyphicon glyphicon-file" />
                </a>
              )}
              {item.file_internal_check_conclusion && (
                <a
                  className="btn btn-primary btn-xs"
                  title="Внутренняя проверка"
                  download
                  href={item.file_internal_check_conclusion.url}
                  onClick={event => event.stopPropagation()}
                >
                  <span className="glyphicon glyphicon-file" />
                </a>
              )}
            </td>
          </>
        ) : null}
      </tr>
    );
  }

  render() {
    const { forms, loaders, pagination } = this.props;

    return (
      <LoadingDots
        show={typeof loaders['forms'] !== 'undefined' || !this.props.modeLoaded}
      >
        {forms.length > 0 && (
          <div className="table-responsive text-block">
            <table className="table table-bordered table-hover request-list">
              {this.renderTableHead()}
              <tbody>
                {forms.map((item, mapId) => this.renderTableRow(item, mapId))}
              </tbody>
            </table>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={this.paginationClick}
              pageRangeDisplayed={5}
              pageCount={Math.ceil(pagination.total / pagination.pagesize)}
              previousLabel="<"
              renderOnZeroPageCount={null}
              className="paginator"
            />
            <HistoryStatusModal ref={modal => (this.modal = modal)} />
            <RejectionModal ref={modal => (this.rejectionModal = modal)} />
          </div>
        )}
        {forms.length === 0 && (
          <div className="text-block text-block_empty">
            Не найдено ни одной заявки
          </div>
        )}
        <LastComment
          ref={modal => (this.lastComment = modal)}
          data={{
            history: this.props.history,
            userRole: this.props.userRole,
            extRules: {
              ActionsRules,
              ActionsDefaultState,
            },
            loaders,
          }}
        />
      </LoadingDots>
    );
  }
}

RequestList.propTypes = {
  forms: PropTypes.array.isRequired,
  pagination: PropTypes.shape({}).isRequired,
  loaders: PropTypes.shape({}).isRequired,
  history: PropTypes.array,
  userRole: PropTypes.string,
  view: PropTypes.string,
};

const mapDispatchToProps = {
  copyForm,
  deleteForm,
  revokeForm,
  getForms,
  getHistory,
  rejectApplication,
};

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    forms: state.forms.forms,
    loaders: state.forms.loaders,
    modeLoaded: state.forms.modeLoaded,
    pagination: state.forms.pagination,
    history: state.forms.history,
    userInfo: state.forms.user,
    userRole: state.forms.user.userRole,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestList);
